<ng-template #loadingTemplate>
  <app-component-loading [size]="'inline'" [margin]="'40px'"></app-component-loading>
</ng-template>

<div class="roadmap"   *ngIf="contractGuid&&this.contractRoadmap?.steps; else loadingTemplate"
[cdkDropListSortPredicate]="contractRestrictionService.dragRoadMapPredicate"     
(cdkDropListDropped)="roadMapChanged($event)"     
cdkDropList>
@for (step of this.contractRoadmap?.steps; track step) {
    <div class="roadmap-item" (click)="openStepForm(step)">
    <!--  [cdkContextMenuTriggerFor]="context_menu" -->
    <ng-template #context_menu>
      <app-contract-context-menu  
        [inputData]="step" 
        [targetContext]="'roadMapStep'"
        [contractGuid]="contractGuid"
        >
      </app-contract-context-menu>
    </ng-template>
    <div class="roadmap-item-number" >{{step.sort_index + 1}}</div>
    <div class="drag-container" 
      cdkDrag [cdkDragData]="step" 
      [cdkDragDisabled]="
        step.completed_at||
        this.contactRights.isContractBlockedForEdit === true||
        (contractDataService.subAlltargetDataIsLoaded |async)!==true ||
        isContractInterDomain === true"
        >
    <div class="roadmap-item-step"
      #stepsDivs  
      [id]="step.guid" 
      [class.active]="selectedContractStep?.guid===step.guid"
      [class.new-step-preview]="step?.guid==='Preview'"
      [style.background]="selectedContractStep?.guid===step.guid? stepsStylingMap.get(step.target_type)?.stepActiveColor : stepsStylingMap.get(step.target_type)?.stepColor"
      >
        <div class="roadmap-item-step-header" *ngIf="step?.tagData?.label">
          <div class="roadmap-item-step-header-status"
              [style.background]="step.tagData?.background"
              [style.color]="step.tagData?.color"
              >
                <mat-icon  
                  *ngIf="step?.tagData?.icon"  
                  [svgIcon]="step?.tagData?.icon" 
                  [class]="'roadmap-item-step-header-status-icon ' + step?.tagData?.iconColor" >
                </mat-icon>
              {{step?.tagData?.label }}
          </div>
          <div class="roadmap-item-step-header-icon" *ngIf="step?.tagData?.additional_icon">
            <mat-icon svgIcon="check-fill" class="base-icon"  style="width: 16px; height: 16px;"></mat-icon>
          </div>
        </div>
        <div class="roadmap-item-step-data" [class.completed]="step.completed_at">
          <div class="roadmap-item-step-data-name">
            <mat-icon style="min-width: 40px; min-height: 40px;"
              [svgIcon]="stepsStylingMap.get(step.target_type)?.stepIcon" 
              class="roadmap-item-step-data-icon base-icon" [class.completed]="step.completed_at">
            </mat-icon>
            <span class="roadmap-item-step-data-name-text">
                {{step.name||step.auto_name||('CONTRACTS.TEXT.STEPS_NAME.GET_INFO'|translate)}}
            </span>
          </div>
<!--                 <div class="roadmap-item-step-data-users" *ngIf="step?.membersAvatarsToShow && contractAvatarsService?.contractAvatarMap">
            <app-contract-avatar *ngFor="let member of step?.membersAvatarsToShow" 
              [avatarSize]="'42px'"
              [userGuid]="member.guid" 
              [checkedState]="member.state">
            </app-contract-avatar>
          </div> -->
          <div class="roadmap-item-step-data-add" 
            *ngIf="
              this.contactRights.isCurrentMemberCanAddTargetsAfter === true &&
              !step?.target_key &&
              ['task','file','sub_contract'].includes(step?.target_type)">
            <button class="button-icon size-m secondary-button"  
              (click)="addTarget(step)">
              <mat-icon svgIcon="add-circle-fill"></mat-icon>
              <span>
                {{'CONTRACTS.CARD.ADD' | translate}} 
                {{'CONTRACTS.TEXT.STEPS2.'+ step?.target_type | translate | lowercase  }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <button 
	*ngIf="this.contactRights?.isContractBlockedForEdit === false &&  ['credit_letter','general_credit_letter'].includes(step?.target_type) === false " 
	(click)="deleteStep(step)" data-action="deleteStep" 
	class="button-icon icononly size-s outline-button roadmap-item-icon-delete shadow-xl"
	[class.active]="selectedContractStep?.guid===step.guid"
	matTooltip="{{ 'CONTRACTS.BUTTONS.DELETE_STEP'  | translate }}" >
		<mat-icon svgIcon="delete-bin-5-line"> </mat-icon>
    </button>
  </div>
}

<div id="scroll" style="margin-top: 180px"></div>
</div>
